/* @ngInject */

export default (
  $q,
  $state,
  $rootScope,
  $scope,
  webpage,
  helperService,
  organizationService,
  accountService,
  lendersService,
  changesService,
  uiService,
  lodgementsService,
  OrganizationEnterprise
) => {
  $scope.Model = {
    availableLenders: [],
    availableGateways: _.filter(lodgementsService.getGateways() || [], 'isActive'),
    filteredLenderCommissions: [],
    isReady: false
  };
  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  $q.all([
    organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
    accountService.readAccount({ id: $rootScope.CurrentAccount.id }),
    lendersService.getAvailable({ cca2: [helperService.getOrganizationCountry().cca2] })
  ])
    .then((data) => {
      // Overwrite $rootScope values in case they've reverted to values within Token

      /* eslint no-param-reassign: "error" */
      $rootScope.CurrentOrganization.enterprise = OrganizationEnterprise.build(
        data[0].enterprise
      );
      $rootScope.CurrentAccount.accreditations = data[1].accreditations;
      $rootScope.CurrentAccount.lenderAccreditations = data[1].lenderAccreditations;
      $rootScope.CurrentAccount.gatewayAccreditations = data[1].gatewayAccreditations;

      // Set Model values
      if ($rootScope.IsEnterprise) {
        $scope.Model.filteredLenderCommissions = _.filter(
          $rootScope.CurrentOrganization.enterprise.lenderCommissions,
          (lc) =>
            lc.upfront !== null &&
            lc.upfront !== undefined &&
            lc.upfront >= 0 &&
            lc.trail !== null &&
            lc.trail !== undefined &&
            lc.trail >= 0
        );
        const availableLenderCommissions = _.map($scope.Model.filteredLenderCommissions, 'id');
        $scope.Model.availableLenders = _.filter(
          data[2],
          (lender) => availableLenderCommissions.indexOf(lender.id) > -1
        );
      } else {
        const lenders = data[2];
        $scope.Model.availableLenders = lenders;
      }
    })
    .then(() => {
      // Declare Model as Ready and start rendering the page
      webpage.pageTitle('My accreditations : Settings');
      $scope.Model.isReady = true;
    });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.previous = () => {
    $state.transitionTo('settings.my-account');
  };

  $scope.next = () => {
    $state.transitionTo('settings.password-and-security');
  };

  $scope.saveAccount = (data) => {
    if (data?.id) {
      $rootScope.CurrentAccount.accreditations = data?.accreditations;
      $rootScope.CurrentAccount.lenderAccreditations = data?.lenderAccreditations;
      $rootScope.CurrentAccount.gatewayAccreditations = data?.gatewayAccreditations;
      changesService.change();
    }
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const accountData = {
      id: $rootScope.CurrentAccount.id,
      accreditations: $rootScope.CurrentAccount.accreditations,
      lenderAccreditations: $rootScope.CurrentAccount.lenderAccreditations,
      gatewayAccreditations: $rootScope.CurrentAccount.gatewayAccreditations
    };
    return accountService.updateAccount(accountData).then((result) => {
      if (result.status) {
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
